import { render, staticRenderFns } from "./CargoClaimUpdateStatus.vue?vue&type=template&id=599ef4eb&"
import script from "./CargoClaimUpdateStatus.vue?vue&type=script&lang=js&"
export * from "./CargoClaimUpdateStatus.vue?vue&type=script&lang=js&"
import style0 from "./CargoClaimUpdateStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoClaimUpdateStatus.vue"
export default component.exports